export default {
  'nav.home': 'Strona główna',
  'nav.categories': 'Kategorie',
  'nav.guides': 'Poradniki',
  'nav.safety': 'Bezpieczeństwo',
  'nav.browse': 'Przeglądaj sklep',
  'nav.shoppingGuide': 'Przewodnik zakupowy',

  'hero.badge': 'Niezależne źródło · Regularnie aktualizowane',
  'hero.title': 'USFans Spreadsheet — Znajdź, uporządkuj i odkrywaj zasoby USFans',
  'hero.subtitle': 'Odkrywaj twórców, kategorie, poradniki i wskazówki bezpieczeństwa w jednym uporządkowanym miejscu. Przeglądaj pełny arkusz USFans i kupuj najnowsze produkty.',
  'hero.ctaPrimary': 'USFans Spreadsheet',
  'hero.ctaSecondary': 'Kup teraz',
  'hero.trust': 'Uporządkowane informacje · Zweryfikowane linki · Prosta nawigacja',

  'categories.title': 'Przeglądaj kategorie USFans',
  'categories.subtitle': 'Przejdź od razu do kategorii, której szukasz w arkuszu USFans.',
  'categories.dropdownLabel': 'Szybkie wyszukiwanie kategorii',
  'categories.dropdownPlaceholder': 'Wybierz kategorię',

  'cat.shoes': 'Buty',
  'cat.hoodies': 'Bluzy / Swetry',
  'cat.tshirts': 'Koszulki',
  'cat.jackets': 'Kurtki',
  'cat.pants': 'Spodnie / Szorty',
  'cat.headwear': 'Nakrycia głowy',
  'cat.sets': 'Zestawy',
  'cat.underwear': 'Bielizna / Majtki',
  'cat.jersey': 'Koszulka sportowa',
  'cat.accessories': 'Akcesoria',
  'cat.bags': 'Torby',
  'cat.belts': 'Paski',
  'cat.perfumes': 'Perfumy',
  'cat.other': 'Inne rzeczy',

  'whatis.title': 'Czym jest USFans Spreadsheet?',
  'whatis.p1': 'USFans Spreadsheet to uporządkowane źródło, które pomaga odkrywać i sprawdzać informacje związane z USFans w jednym miejscu.',
  'whatis.p2': 'Zamiast przeszukiwać rozproszone strony, możesz eksplorować uporządkowane kategorie, informacje o twórcach, poradniki i wskazówki bezpieczeństwa z jednego wygodnego centrum.',
  'whatis.p3': 'Odkrywaj, porównuj i weryfikuj — wszystko, czego potrzebujesz, jest zebrane i posortowane dla szybszego przeglądania.',

  'value.title': 'Wszystko, czego potrzebujesz do eksploracji USFans w jednym miejscu',
  'value.subtitle': 'Jedno uporządkowane centrum z narzędziami i tematami, których ludzie szukają najczęściej.',
  'value.item1': 'USFans Spreadsheet',
  'value.item2': 'Katalog twórców',
  'value.item3': 'Poradniki wyszukiwania i odkrywania',
  'value.item4': 'Recenzje i porównania',
  'value.item5': 'Informacje o wysyłce',
  'value.item6': 'Zasoby kuponów',
  'value.item7': 'Poradniki magazynowe',
  'value.item8': 'Bezpieczeństwo i ochrona',

  'popular.title': 'Popularne wyszukiwania USFans',
  'popular.subtitle': 'Szybko poznaj tematy, których ludzie szukają najczęściej.',
  'popular.review.title': 'Recenzja USFans',
  'popular.review.desc': 'Poznaj funkcje, doświadczenia użytkowników, zalety i ważne uwagi.',
  'popular.shipping.title': 'Koszt wysyłki USFans',
  'popular.shipping.desc': 'Zrozum informacje o wysyłce, czynniki cenowe i to, co wpływa na całkowity koszt.',
  'popular.coupon.title': 'Kupon USFans',
  'popular.coupon.desc': 'Znajdź informacje o dostępnych promocjach, ofertach i zasobach kuponów.',
  'popular.discount.title': 'Kod rabatowy USFans',
  'popular.discount.desc': 'Poznaj aktualne informacje o zniżkach i dowiedz się, jak weryfikować oferty promocyjne.',
  'popular.warehouse.title': 'Magazyn USFans',
  'popular.warehouse.desc': 'Dowiedz się, jak działają usługi i procesy związane z magazynem.',
  'popular.legit.title': 'Czy USFans jest legalny',
  'popular.legit.desc': 'Zrozum, jak ocenić wiarygodność, sygnały zaufania, bezpieczeństwo witryny i potencjalne ryzyko.',

  'comparison.title': 'Porównanie zasobów USFans',
  'comparison.subtitle': 'Szybki przegląd tego, jak każde źródło pomaga w eksploracji USFans.',
  'comparison.col1': 'Źródło',
  'comparison.col2': 'Najlepsze do',
  'comparison.col3': 'Organizacja',
  'comparison.col4': 'Aktualizacje',
  'comparison.col5': 'Dla początkujących',
  'comparison.r1': 'USFans Spreadsheet',
  'comparison.r1best': 'Uporządkowane badania',
  'comparison.r2': 'Katalog twórców',
  'comparison.r2best': 'Odkrywanie twórców',
  'comparison.r3': 'Poradnik wyszukiwania',
  'comparison.r3best': 'Znajdowanie informacji',
  'comparison.r4': 'Poradnik recenzji',
  'comparison.r4best': 'Ocena opcji',

  'safety.title': 'Bądź bezpieczny podczas eksploracji zasobów USFans',
  'safety.p': 'Zawsze weryfikuj linki przed kliknięciem, unikaj podejrzanych stron logowania, nigdy nie udostępniaj haseł, chroń swoje dane osobowe i zachowaj ostrożność przy nieznanych pobraniach lub prośbach o płatność.',
  'safety.link': 'Przeczytaj nasz poradnik bezpieczeństwa',

  'articles.title': 'Poradniki i artykuły USFans',
  'articles.subtitle': 'Oryginalne, dogłębne materiały, które pomogą Ci w pełni wykorzystać arkusz USFans.',
  'articles.cardTitle': 'USFans Spreadsheet: Kompletny poradnik',
  'articles.cardDesc': 'Wszystko, co musisz wiedzieć o znajdowaniu, porządkowaniu i eksploracji zasobów USFans — kategorie, wskazówki i bezpieczeństwo.',
  'articles.readMore': 'Przeczytaj poradnik',

  'final.title': 'Gotowy na eksplorację USFans Spreadsheet?',
  'final.subtitle': 'Znajdź uporządkowane informacje, przydatne poradniki i często wyszukiwane tematy USFans w jednym centralnym miejscu.',
  'final.cta': 'Poznaj USFans Spreadsheet',

  'footer.tagline': 'Niezależne źródło informacji o arkuszu USFans i wszystkim, co go otacza.',
  'footer.disclaimer': 'USFansLink.cfd jest niezależnym źródłem informacji i nie jest powiązany z USFans ani przez niego sponsorowany, chyba że wyraźnie to zaznaczono.',
  'footer.quickLinks': 'Szybkie linki',
  'footer.resources': 'Zasoby',
  'footer.copyright': 'Wszelkie prawa zastrzeżone.',
};